import { render, staticRenderFns } from "./IntroModal.vue?vue&type=template&id=a12eed72"
import script from "./IntroModal.vue?vue&type=script&lang=js"
export * from "./IntroModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports